import classNames from 'classnames';
import React from 'react';

import {useMatchMedia} from '@udemy/hooks';
import {Icon} from '@udemy/icons';

import {LearningPathStepStatus, LearningPathStepType} from '../learning-path-status';
import styles from './order-bar.module.less';

import type {StepStatus} from '../learning-path-status';

type StepNodeProps = {
    status: StepStatus;
    type: LearningPathStepType;
    displayIndex: number;
};

export interface OrderBarProps {
    displayIndex: number;
    status: StepStatus;
    type: LearningPathStepType;
    className?: string;
    removeMargin?: boolean;
}

const StepNode = ({status, type, displayIndex}: StepNodeProps) => {
    const isMobile = useMatchMedia('mobile-max');

    if (type === LearningPathStepType.Tracker) {
        return (
            <Icon
                glyph="certificate"
                color="inherit"
                label={false}
                size={isMobile ? 'small' : 'large'}
            />
        );
    }

    switch (status) {
        case LearningPathStepStatus.Completed:
            return <Icon glyph="tick" label={false} size={isMobile ? 'small' : 'large'} />;
        case LearningPathStepStatus.InProgress:
            return <span className={styles['step-node-index']}>{displayIndex}</span>;
        default:
            return null;
    }
};

export function OrderBar({
    displayIndex,
    status,
    type,
    className,
    removeMargin = false,
}: OrderBarProps) {
    const isCompleted = status === LearningPathStepStatus.Completed;
    const isTrackerCompleted = type === LearningPathStepType.Tracker && isCompleted;
    return (
        <div
            className={classNames(styles['step-node'], className, {
                [styles['step-node--completed']]: isCompleted,
                [styles['step-node--tracker-completed']]: isTrackerCompleted,
                [styles['step-node--no-margin']]: removeMargin,
            })}
        >
            <StepNode status={status} type={type} displayIndex={displayIndex} />
        </div>
    );
}
